"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgLink = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ fill: "none", height: 14, width: 14, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsxs)("g", __assign({ fill: "#191933" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M5.185 3.51c-1.65 1.707-1.29 4.54.6 5.794a.159.159 0 0 0 .199-.02c.398-.388.734-.764 1.029-1.243a.15.15 0 0 0-.059-.21 1.921 1.921 0 0 1-.736-.758 1.849 1.849 0 0 1-.157-1.262c.118-.571.73-1.102 1.199-1.593l-.003-.001 1.753-1.79a1.799 1.799 0 0 1 2.555-.013 1.82 1.82 0 0 1 .026 2.567l-1.062 1.093a.186.186 0 0 0-.042.19c.244.71.304 1.71.14 2.465-.004.022.022.035.037.02l2.26-2.307a3.81 3.81 0 0 0-.026-5.333 3.793 3.793 0 0 0-5.387.027L5.194 3.5l-.009.01z" }), (0, jsx_runtime_1.jsx)("path", { d: "M9.411 9.63a.257.257 0 0 0 .005-.002c.461-.844.552-1.811.336-2.754H9.75a3.805 3.805 0 0 0-1.534-2.188.21.21 0 0 0-.233.011c-.387.314-.767.715-1.017 1.228a.17.17 0 0 0 .068.222c.29.169.552.416.728.744.137.231.272.67.185 1.143-.082.625-.714 1.2-1.217 1.717l-1.743 1.78a1.82 1.82 0 0 1-2.568.027 1.82 1.82 0 0 1-.026-2.568l1.065-1.095a.186.186 0 0 0 .044-.188c-.237-.726-.302-1.703-.152-2.458.004-.02-.022-.034-.037-.019L1.086 7.503a3.849 3.849 0 0 0 .028 5.387 3.801 3.801 0 0 0 5.36-.055C6.98 12.268 9.15 10.26 9.41 9.63z" })] })) }))); };
exports.default = SvgLink;
